import React from "react";
import Navigation from "../components/Navigation/Navigation";
import HeroSection from "../components/HeroSection/HeroSection";
import AboutSection from "../components/AboutSection/AboutSection";
import PackagesSection from "../components/PackagesSection";
import ServicesSection from "../components/ServicesSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import PhoneButton from "../components/PhoneButton";

const HomePage = () => {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <Navigation />

      <PhoneButton />

      <section id="home-section">
        <HeroSection />
      </section>

      <section id="about-section">
        <AboutSection />
      </section>

      <section id="packages-section">
        <PackagesSection />
      </section>

      <section id="services-section">
        <ServicesSection />
      </section>

      <section id="contact-section">
        <ContactSection />
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
